<div class="kz-breadcrumb-container">
  <ol class="kz-breadcrumb">
    <li aria-current="page">
      <a [routerLink]="['/'] | localize" [queryParams]="{noredirect: true}" [innerHTML]="homeLabel"></a>
      <kz-icons name="arrowright"></kz-icons>
    </li>
    <li *ngFor="let breadcrumb of breadcrumbs; last as isLast; trackBy: trackLabels;"
        class="breadcrumb-item"
        [ngClass]="{'active': isLast}" aria-current="page"
    >
      <a *ngIf="!isLast; else label"
         [routerLink]="breadcrumb.url | localize"
         routerLinkActive="active">
        <ng-container *ngTemplateOutlet="label"></ng-container>
      </a>
      <ng-template #label>
        {{breadcrumb.label}}
      </ng-template>
      <kz-icons *ngIf="!isLast" name="arrowright"></kz-icons>
    </li>
  </ol>
</div>
<div [innerHTML]="jsonUpdated$ | async"></div>
